import { TContactInitialState } from '../types';

export const DEFAULT_CONTACT_STATE: TContactInitialState = {
    contact: null,
    contacts: null,
    total: 0,
    loading: false,
    loadingContactList: false,
    error: null,
    success: null,
};
